// extracted by mini-css-extract-plugin
module.exports = {"root":"_1w0tU","responsive-root":"_2IqWW","responsiveRoot":"_2IqWW"};